export default "__VITE_ASSET__7b63b588__"